export class DomainHelper {
  public static getDomain(): string {
    let domain = "localhost";
    const domainSplit = window.location.hostname.split(".");
    if (domainSplit.length > 0) {
      domain = domainSplit.slice(1).join(".");
    }

    return domain;
  }
}
